module.exports = __webpack_public_path__ + "img/bcg-platinion-logo.2cea4123.svg";